import { formatNumber } from "@/i18n";
import type en from "@/i18n/messages/settings-billing/en";

/** What Pro adds, as settings-billing catalogue keys. */
export const DENKER_BENEFIT_KEYS = [
  "benefitUnlimitedRequests",
  "benefitUnlimitedProjects",
  "benefitMemory",
] as const satisfies ReadonlyArray<keyof typeof en>;

/** The monthly amount new checkouts accept (checkout_services.py), e.g. "€19". */
export function newCheckoutAmount(): string {
  return formatNumber(19, {
    style: "currency",
    currency: "EUR",
    minimumFractionDigits: 0,
  });
}
